export default "__VITE_PUBLIC_ASSET__31ebf539__"